import React            from 'react';
import PropTypes        from 'prop-types';
import classNames       from 'classnames';

import { Link }         from 'react-router-dom';

import useFooter        from './useFooter';

import Button           from '../Button';

import LogoWhite        from '../../../assets/images/logo_white.png';
import Logo             from '../../../assets/images/logo_black.png';
import Icons            from '../../../assets/svg/icons.js';

import styles           from './Footer.styl';

function Footer(props) {
    const {
        className,
        theme
    } = props;

    const {
        handleScrollTo
    } = useFooter(props);

    function handleRenderLink(name, refName) {
        return theme !== 'light'
            ? (
                <div
                    className = {classNames(styles.link, {
                        [styles.lightLink]: theme === 'light'
                    })}
                    onClick = {handleScrollTo(refName)}
                >
                    {name}
                </div>
            )
            :
            (
                <Link
                    to = '/'
                    className = {classNames(styles.link, {
                        [styles.lightLink]: theme === 'light'
                    })}
                >
                    {name}
                </Link>
            )
    
    }

    return  (
        <div className={classNames(styles.Footer, className, {
            [styles.lightFooter]: theme === 'light'
        })}>
            <div className={styles.wrapper}>
                <div className={classNames(styles.column, styles.first)}>
                    <div className={styles.footerItem}>
                        <Link to='/'>
                            <img
                                src       = {
                                    theme === 'light'
                                        ? Logo
                                        : LogoWhite
                                }
                                className = {styles.logo}
                            />
                        </Link>
                    </div>
                    <div className={classNames(styles.footerItem, styles.mobile)}>
                        {handleRenderLink('Features', 'servicesRef')}
                    </div>
                    <div className={classNames(styles.footerItem, styles.mobile)}>
                        {handleRenderLink('Potential', 'resultsRef')}
                    </div>
                    <div className={classNames(styles.footerItem, styles.mobile)}>
                        {handleRenderLink('Setup', 'stepsRef')}
                    </div>
                    <div className={classNames(styles.footerItem, styles.mobile)}>
                        {handleRenderLink('Opportunities', 'opportunitiesRef')}
                    </div>
                    <div className={classNames(styles.footerItem, styles.mobile)}>
                        {handleRenderLink('Revolutionary', 'revolutionaryRef')}
                    </div>
                    <div className={classNames(styles.footerItem, styles.mobile)}>
                        {handleRenderLink('Availability', 'availabilityRef')}
                    </div>
                    <div className={classNames(styles.footerItem, styles.mobile)}>
                        <Link
                            to='/'
                            className={classNames(styles.link, {
                                [styles.lightLink]: theme === 'light'
                            })}
                        >
                            Contact Us
                        </Link>
                    </div>
                    <div className={classNames(styles.footerItem, styles.socialItem)}>
                        <div className={styles.socialWrapper}>
                            {theme === 'light'
                                ? <Icons.FbBlack />
                                : <Icons.FbWhite />
                            }
                        </div>
                        <div className={styles.socialWrapper}>
                            {theme === 'light'
                                ? <Icons.InstaBlack />
                                : <Icons.InstaWhite />
                            }
                        </div>
                    </div>
                    <div className={styles.footerItem}>
                        <span className={classNames(styles.itemText, {
                            [styles.lightLink]: theme === 'light'
                        })}>
                        © 2022 Roimax.ai
                        </span>
                    </div>
                </div>
                <div className={classNames(styles.column, styles.second)}>
                    <div className={styles.footerItem}>
                        {handleRenderLink('Features', 'servicesRef')}
                    </div>
                    <div className={styles.footerItem}>
                        {handleRenderLink('Potential', 'resultsRef')}
                    </div>
                    <div className={styles.footerItem}>
                        {handleRenderLink('Setup', 'stepsRef')}
                    </div>
                    <div className={styles.footerItem}>
                        {handleRenderLink('Opportunities', 'opportunitiesRef')}
                    </div>
                    <div className={styles.footerItem}>
                        {handleRenderLink('Revolutionary', 'revolutionaryRef')}
                    </div>
                    <div className={styles.footerItem}>
                        {handleRenderLink('Availability', 'availabilityRef')}
                    </div>
                    <div className={styles.footerItem}>
                        <Link
                            to='/'
                            className={classNames(styles.link, {
                                [styles.lightLink]: theme === 'light'
                            })}
                        >
                            Contact Us
                        </Link>
                    </div>
                </div>
                <div className={classNames(styles.column, styles.third)}>
                    <div className={styles.footerItem}>
                        <Link
                            to='/terms'
                            className={classNames(styles.link, {
                                [styles.lightLink]: theme === 'light'
                            })}
                        >
                            {'Terms & Conditions'}
                        </Link>
                    </div>
                    <div className={styles.footerItem}>
                        <Link
                            to='/privacy-policy'
                            className = {classNames(styles.link, {
                                [styles.lightLink]: theme === 'light'
                            })}
                        >
                        Privacy Policy
                        </Link>
                    </div>
                </div>
                <div className={classNames(styles.column, styles.fourth)}>
                    <div className={styles.footerItem}>
                        <div className={styles.secondaryText}>
                        Useful links:
                        </div>
                    </div>
                    <div className={styles.footerItem}>
                        <Link
                            to='/'
                            className={classNames(styles.link, {
                                [styles.lightLink]: theme === 'light'
                            })}
                        >
                        Platform Status
                        </Link>
                    </div>
                </div>
                <div className={classNames(styles.column, styles.fifth)}>
                    <div className={styles.footerItem}>
                        <Link
                            to = '/create-account'
                            className={styles.buttonLink}
                        >
                            <Button
                                className = {styles.startButton}
                                color     = {
                                    theme === 'light'
                                        ? ''
                                        : 'white' 
                                }
                            >
                            Start free trial
                            </Button>
                        </Link>
                    </div>
                    <div className={classNames(styles.footerItem, styles.mobile)}>
                        <Link
                            to='/terms'
                            className={classNames(styles.link, {
                                [styles.lightLink]: theme === 'light'
                            })}
                        >
                            {'Terms & Conditions'}
                        </Link>
                    </div>
                    <div className={classNames(styles.footerItem, styles.mobile)}>
                        <Link
                            to='/privacy-policy'
                            className = {classNames(styles.link, {
                                [styles.lightLink]: theme === 'light'
                            })}
                        >
                        Privacy Policy
                        </Link>
                    </div>
                    <div className={classNames(styles.footerItem, styles.tablet)}>
                        <div className={styles.secondaryText}>
                        Useful links:
                        </div>
                    </div>
                    <div className={classNames(styles.footerItem, styles.tablet)}>
                        <Link
                            to='/'
                            className={classNames(styles.link, {
                                [styles.lightLink]: theme === 'light'
                            })}
                        >
                        Platform Status
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

Footer.propTypes = {
    className : PropTypes.string,
    theme     : PropTypes.string
};

Footer.defaultProps = {
    className : '',
    theme     : 'dark'
};

export default Footer;
